const algoliaStringFormatter = (value: string) =>
  value
    .replaceAll(' ', '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export default algoliaStringFormatter;
